import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    params: { lang: 'en' }, // Default language
});

export const fetchEvents = async ({ status, page, lang }) => {
    try {
        const response = await apiClient.get(endpoints.events.list, {
            params: {
                status,
                page: page || 1,
                lang,
                ordering: '-start_date',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching events:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch events');
    }
};

export const fetchEventDetails = async (slug, lang) => {
    try {
        const response = await apiClient.get(endpoints.events.detail(slug), {
            params: { lang },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching event details:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch event details');
    }
};